import type { FC } from "react";

import { truncateValues, useMaxProductCharactersLength, VALUES_SEPARATOR } from "../utils";

import styles from "./StoreLocatorProductAttributeValues.module.scss";

type StoreLocatorProductAttributeValuesProps = {
  values: { value: string | number }[];
  isListView: boolean;
};

export const StoreLocatorProductAttributeValues: FC<StoreLocatorProductAttributeValuesProps> = ({
  values,
  isListView,
}) => {
  const maxProductCharactersLength = useMaxProductCharactersLength();
  const formattedValues = values.map(({ value }) => value.toString());
  const { displayedValues, restCount } = truncateValues(formattedValues, isListView, maxProductCharactersLength);
  const result = displayedValues.join(VALUES_SEPARATOR);

  return (
    <div className={styles.productAttributeValues} data-testid="storeLocatorAttributeValues">
      {result}
      {restCount > 0 && (
        <div className={styles.productAttributeValuesCount} data-testid="attributeValuesCount">
          {" "}
          + {restCount}
        </div>
      )}
    </div>
  );
};
